module.exports = {
      id: "d1f64c703a74cb2eec5e752fdd6cb557kitchenEquipment-fitted-kitchen.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#d1f64c703a74cb2eec5e752fdd6cb557kitchenEquipment-fitted-kitchen.svg",
      toString: function () {
        return this.url;
      }
    }